import { Effect, Layer } from "effect";
import { BrowserHttpClient } from "@effect/platform-browser";
import { withWorkerstationBase } from "@workerstation/shared/base-path";
import { makeExecutionApi } from "../../api/execution/live.ts";
import { ExecutionApi } from "../../api/execution/service.ts";
import { RecordingRecentScopes } from "../../recording/recent-scopes/service.ts";
import { RecordingRecentScopesLive } from "../../recording/recent-scopes/live.ts";
import { ExecutionBrowserIo } from "./service.ts";

export const ExecutionBrowserIoLive = Layer.effect(ExecutionBrowserIo, Effect.gen(function* () {
  const scopes = yield* RecordingRecentScopes;
  return ExecutionBrowserIo.of({ remember: (workspaceId, values) => scopes.remember(workspaceId, values).pipe(Effect.asVoid) });
})).pipe(Layer.provide(RecordingRecentScopesLive));
const BrowserExecutionApiLive = Layer.effect(ExecutionApi, Effect.gen(function* () {
  const base = yield* Effect.sync(() => (typeof window === "undefined" ? "https://workerstation.invalid" : window.location.origin) + withWorkerstationBase(""));
  return yield* makeExecutionApi(base);
})).pipe(Layer.provide(BrowserHttpClient.layerFetch));
export const ExecutionBrowserPortsLive = Layer.merge(BrowserExecutionApiLive, ExecutionBrowserIoLive);
export const ExecutionBrowserIoTest = (io: typeof ExecutionBrowserIo.Service) => Layer.succeed(ExecutionBrowserIo, io);
